export default __webpack_public_path__ + "static/media/img_blanket_beige_p.414254df.jpg";